import { render } from "./BcListPage.vue?vue&type=template&id=59fd9aea&scoped=true"
import script from "./BcListPage.vue?vue&type=script&lang=js"
export * from "./BcListPage.vue?vue&type=script&lang=js"

import "./BcListPage.vue?vue&type=style&index=0&id=59fd9aea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fd9aea"]])

export default __exports__